import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/shared/services/breadcrumbs.service';
import { EnvioSimpleFlowService } from '../../services/envio-simple-flow.service';

@Component({
  selector: 'app-envio-simple-confirmacion-page',
  templateUrl: './envio-simple-confirmacion-page.component.html',
  styleUrls: ['./envio-simple-confirmacion-page.component.css']
})
export class EnvioSimpleConfirmacionPageComponent implements OnInit {
  constructor(
    public envioSimpleFlowService: EnvioSimpleFlowService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router
  ) {}

  get resultado() {
    return this.envioSimpleFlowService.confirmacionResultado;
  }

  get esExito(): boolean {
    return this.resultado?.estadoGlobal === 'Exito';
  }

  get mostrarEmail(): boolean {
    return this.envioSimpleFlowService.canalesEnvio.envioMail;
  }

  get mostrarTelefono(): boolean {
    return this.envioSimpleFlowService.canalesEnvio.envioSMS;
  }

  ngOnInit(): void {
    if (!this.envioSimpleFlowService.tieneDocumentos || !this.resultado) {
      this.router.navigate(['/panel/envio-simple/envio']);
      return;
    }
    this.envioSimpleFlowService.establecerPaso(3);
    this.breadcrumbsService.addBreadcrumbs('Confirmación');
  }

  irAlPanel(): void {
    this.router.navigate(['/panel/envios']);
  }
}
